module.exports = __webpack_public_path__ + "static/media/cartoon_yaoxin.b606c68f.png";